export default __webpack_public_path__ + "locales/en/ArchiveDialog.json?hash=9e1af0c62d55c07d6d5164f04b96ef69";